import { DriveItemSearchResult } from "../../interfaces/IDriveItemSearchResult";
import { DriveItemSearchResultComposite } from "../../interfaces/DriveItemSearchResultComposite";
import { IMapper } from "../../interfaces/IMapper";



export class SearchResultMapper implements IMapper<DriveItemSearchResultComposite> {
    map(data: any[]): DriveItemSearchResultComposite {
        const noResultsAvailable = data.length !== 1 || !data[0].hitsContainers[0].hits;
        return {
            items: noResultsAvailable ? [] : data[0].hitsContainers[0].hits.map(this.mapDriveItems),
            totalResults: noResultsAvailable ? 0 : data[0].hitsContainers[0].total
        }
    }

    private mapDriveItems = (item): DriveItemSearchResult => {
        return ({
            id: item._source.id,
            name: item._source.name,
            webUrl: item._source.webUrl
        })
    }
}
